import React, { createContext, useState, useEffect, useContext } from 'react';

const ConfigContext = createContext();

//Para cargar la URL API especificada por el usuario
export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/config.json')
      .then((res) => res.json())
      .then((data) => {
        setConfig(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error cargando configuración:", err);
        setLoading(false);
      });
  }, []);

  return (
    <ConfigContext.Provider value={config}>
      {!loading ? children : <div>...</div>}
    </ConfigContext.Provider>
  );
};

// Hook personalizado para usar la config fácilmente
export const useConfig = () => useContext(ConfigContext);